/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharePrefilledInfoRequest
 */
export interface SharePrefilledInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof SharePrefilledInfoRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SharePrefilledInfoRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SharePrefilledInfoRequest
     */
    prefilledCode?: string;
}

/**
 * Check if a given object implements the SharePrefilledInfoRequest interface.
 */
export function instanceOfSharePrefilledInfoRequest(value: object): value is SharePrefilledInfoRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SharePrefilledInfoRequestFromJSON(json: any): SharePrefilledInfoRequest {
    return SharePrefilledInfoRequestFromJSONTyped(json, false);
}

export function SharePrefilledInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharePrefilledInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'prefilledCode': json['prefilledCode'] == null ? undefined : json['prefilledCode'],
    };
}

  export function SharePrefilledInfoRequestToJSON(json: any): SharePrefilledInfoRequest {
      return SharePrefilledInfoRequestToJSONTyped(json, false);
  }

  export function SharePrefilledInfoRequestToJSONTyped(value?: SharePrefilledInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'prefilledCode': value['prefilledCode'],
    };
}

